<template>
    <custom-search
        :label="label"
        :display-value="itemCurrent.name"
        :disabled="!enabled"
        placeholder="Buscar categoría .."
        :fetch-items="searchLines"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    />
</template>

<script>
import { mapActions } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

export default {
    name: "LinesSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            type: Object,
            required: false,
            default: () => ({
                active: true
            })
        },
        itemCurrent: {
            type: Object,
            required: false,
            default: () => ({ name: "" })
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    methods: {
        ...mapActions("commons", ["listAllLinesAndSublines"]),
        searchLines(keyword, required = false) {
            return this.listAllLinesAndSublines({
                ...this.defaultFilters,
                keyword,
                required
            });
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
